import '../styles/PortfolioTopNav.css';
import React, { useEffect, useState } from 'react';

const NAV_LINKS = [
  { page: 'Landing', label: 'Landing', href: '/' },
  { page: 'Portfolio', label: 'Portfolio', href: '/portfolio' },
  { page: 'Contact', label: 'Contact', href: '/contact' },
];

const normalise = (path) => {
  if (!path) return '';
  const clean = String(path).split('?')[0].split('#')[0].replace(/\/+$/, '');
  return clean === '' ? '/' : clean.toLowerCase();
};

const resolveActivePage = (activePage) => {
  if (activePage && String(activePage).trim()) {
    const wanted = String(activePage).trim().toLowerCase();
    const match = NAV_LINKS.find((link) => link.page.toLowerCase() === wanted);
    return match ? match.page : '';
  }
  if (typeof window === 'undefined') return '';
  const current = normalise(window.location.pathname);
  const byPath = NAV_LINKS.find((link) => normalise(link.href) === current);
  return byPath ? byPath.page : '';
};

export default function PortfolioTopNav({ activePage }) {
  const [current, setCurrent] = useState(() => resolveActivePage(activePage));

  useEffect(() => {
    setCurrent(resolveActivePage(activePage));
  }, [activePage]);

  useEffect(() => {
    if (activePage && String(activePage).trim()) return undefined;
    const onPop = () => setCurrent(resolveActivePage(''));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [activePage]);

  return (
    <header className="ptn-header" data-nav-root>
      <div className="ptn-inner">
        <nav className="ptn-nav" aria-label="Primary">
          {NAV_LINKS.map((link) => {
            const isActive = link.page === current;
            return (
              <a
                key={link.href}
                className="ptn-link"
                href={link.href}
                aria-current={isActive ? 'page' : undefined}
              >
                <span className="ptn-label">{link.label}</span>
                <span className="ptn-arc" aria-hidden="true" />
              </a>
            );
          })}
        </nav>
      </div>
      <span className="ptn-hairline" aria-hidden="true" />
    </header>
  );
}